import type { FunctionComponent } from "react";

import Button from "~/components/buttons/Button";
import CardContent from "~/components/Card/components/CardContent";
import CardHeader from "~/components/Card/components/CardHeader";
import CardTitle from "~/components/Card/components/CardTitle";
import CardWrapper from "~/components/Card/components/CardWrapper";
import DetailsListDivider from "~/components/DetailsList/components/DetailsListDivider";
import DetailsListItem from "~/components/DetailsList/components/DetailsListItem";
import StatusBadge from "~/components/StatusBadge";
import { EMPTY_VALUE_PLACEHOLDER } from "~/constants/textConstants.ts";
import {
	getInvoiceStatusDisplayNameById,
	getInvoiceStatusThemeById,
} from "~/modules/billing/api/invoiceStatus/invoiceStatusId.ts";
import { invoiceTypeId } from "~/modules/billing/api/invoiceType.ts";
import type { Invoice } from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";
import { formatDateWithGermanMonth } from "~/utils/dateAndTimeUtils.ts";

type Props = { invoiceData: Invoice, onUpdateClick?: () => void };

const InvoiceStatusSection: FunctionComponent<Props> = ({ invoiceData, onUpdateClick }) => {
	const isSelfBilledInvoice = invoiceData.invoiceTypeId === invoiceTypeId.SelfBilledInvoice;
	const transactionDate = isSelfBilledInvoice ? invoiceData.invoiceReceivedAt : invoiceData.invoiceSentAt;
	const recipientOrSenderInformation = isSelfBilledInvoice ? invoiceData.senderInformation : invoiceData.recipientInformation;
	return <CardWrapper hasTitle={true}
						padding="none">
		<CardHeader hasTitle={true}>
			<CardTitle>Status</CardTitle>
			<div className="ml-2 mr-auto">
				<StatusBadge theme={getInvoiceStatusThemeById(invoiceData.invoiceStatusId)}>{getInvoiceStatusDisplayNameById(invoiceData.invoiceStatusId)}</StatusBadge>
			</div>
			{onUpdateClick && <Button size="auto"
					theme="plain"
					className="px-2 py-1 text-xs"
					onClick={onUpdateClick}>Bearbeiten</Button>}
		</CardHeader>
		<CardContent padding="none">
			<div className="grid grid-cols-[auto_1fr] gap-4 px-4 py-3">
				<DetailsListItem label={isSelfBilledInvoice ? "Eingegangen am":"Versendet am"}>
					{transactionDate ? formatDateWithGermanMonth(new Date(transactionDate)) : EMPTY_VALUE_PLACEHOLDER}
				</DetailsListItem>
				<DetailsListDivider />
				<DetailsListItem label={isSelfBilledInvoice ? "Absender":"Versendet an"} truncate={false}>
					{recipientOrSenderInformation || EMPTY_VALUE_PLACEHOLDER}
				</DetailsListItem>
				<DetailsListDivider />
				<DetailsListItem label="Gebucht am">
					{invoiceData.invoicePaidAt ? formatDateWithGermanMonth(new Date(invoiceData.invoicePaidAt)) : EMPTY_VALUE_PLACEHOLDER}
				</DetailsListItem>
			</div>
		</CardContent>
	</CardWrapper>;
};

export default InvoiceStatusSection;